import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = {
  key: 0,
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_4 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_5 = { class: "pb-5 mb-4" }
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = { class: "text-center vote-buttons" }
const _hoisted_8 = { class: "vote-value" }
const _hoisted_9 = { class: "col pt-0" }
const _hoisted_10 = { class: "fs-5 fw-bold mb-1" }
const _hoisted_11 = { class: "small mb-0" }
const _hoisted_12 = { class: "mb-5" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "row align-items-center question-info" }
const _hoisted_15 = {
  key: 0,
  class: "col text-end v-list-item-subtitle question-info-user"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "ps-1" }
const _hoisted_18 = { class: "ps-0" }
const _hoisted_19 = ["id"]
const _hoisted_20 = { class: "question-answer-img" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "col pt-0 ps-1" }
const _hoisted_23 = { class: "d-flex flex-wrap justify-content-between align-items-center" }
const _hoisted_24 = { class: "text-grey pe-4 mb-1" }
const _hoisted_25 = { class: "text-primary text-end small mb-1" }
const _hoisted_26 = { class: "my-4" }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_29 = {
  class: "fw-bold",
  ref: "toggleAnswerLabel"
}
const _hoisted_30 = { class: "d-flex" }
const _hoisted_31 = { class: "ps-0" }
const _hoisted_32 = ["id"]
const _hoisted_33 = { class: "question-answer-img" }
const _hoisted_34 = ["src"]
const _hoisted_35 = { class: "col pt-0 ps-1" }
const _hoisted_36 = { class: "d-flex flex-wrap justify-content-between align-items-center" }
const _hoisted_37 = { class: "text-grey pe-4 mb-1" }
const _hoisted_38 = { class: "text-primary text-end small mb-1" }
const _hoisted_39 = { class: "my-4" }
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = { class: "ps-0" }
const _hoisted_42 = ["id"]
const _hoisted_43 = { class: "question-answer-img" }
const _hoisted_44 = ["src"]
const _hoisted_45 = { class: "col pt-0 ps-1" }
const _hoisted_46 = { class: "d-flex flex-wrap justify-content-between align-items-center" }
const _hoisted_47 = { class: "text-grey pe-4 mb-1" }
const _hoisted_48 = { class: "text-primary text-end small mb-1" }
const _hoisted_49 = { class: "my-4" }
const _hoisted_50 = ["innerHTML"]
const _hoisted_51 = { class: "mt-3 py-2" }

import { ref, onMounted } from 'vue'
import UserQuestion from "../../../api/v2/models/user_question"
import { format } from "date-fns"
import VoteForm from "../../../api/v2/forms/vote"
import api from "../../../api/v2/api"
import AnswerForm from "../../../api/v2/forms/answer"
import Simplemde from "../atoms_molecules/Simplemde.vue"
import CommentCreation from "../atoms_molecules/CommentCreation.vue"
import UserAnswer from "../../../api/v2/models/user_answer"
import CommentForm from "../../../api/v2/forms/comment"
import {makeChannel, removeChannel} from '../../../../action_cable/cable'


export default /*@__PURE__*/_defineComponent({
  __name: 'UserQuestionDetailModal',
  props: {
    showCloseButton: { type: Boolean, default: true },
    question: {},
    onBack: {}
  },
  setup(__props: any) {

const props = __props

const currentQuession = ref<UserQuestion | null>(null)
const answerFiles = ref<File[]>([])
const newAnswer = ref('')
const answerToggle = ref(false)
const channel = ref<any>(null)

const getCurrentQuestion = async () => {
  currentQuession.value = await api.userQuestion.show(`${props.question.id}`)
}

const dateFormat = (date: Date | string) => {
  return format(new Date(date), "YYYY/MM/DD HH:mm")
}

const upVote = async (voteMark: number, votableId: number, votableType: 'Question' | 'Course' | 'Answer' | 'Lesson' | 'Comment') => {
  if (voteMark == 1) {
    return
  }
  try {
    const voteForm = new VoteForm()
    voteForm.value = Math.min(voteMark + 1, 1)
    voteForm.votableId = votableId
    voteForm.votableType = votableType
    await api.vote.create(voteForm)
    currentQuession.value = await api.userQuestion.show(
      `${currentQuession.value!.id}`
    )
  } catch (e) {
  } finally {
  }
}

const downVote = async (voteMark: number, votableId: number, votableType: 'Question' | 'Course' | 'Answer' | 'Lesson' | 'Comment') => {
  if (voteMark == -1) {
    return
  }
  try {
    const voteForm = new VoteForm()
    voteForm.value = Math.max(voteMark - 1, -1)
    voteForm.votableId = votableId
    voteForm.votableType = votableType
    await api.vote.create(voteForm)
    currentQuession.value = await api.userQuestion.show(
      `${currentQuession.value!.id}`
    )
  } catch (e) {
  } finally {
  }
}

const createAnswer = async () => {
  if (!currentQuession.value) return
  try {
    const answerForm = new AnswerForm()
    answerForm.body = newAnswer.value
    answerForm.question_id = `${currentQuession.value.id}`
    answerForm.materials = answerFiles.value
    await api.answer.create(answerForm)

    newAnswer.value = ""
    answerFiles.value = []
    currentQuession.value = await api.userQuestion.show(
      `${currentQuession.value.id}`
    )

    answerToggle.value = false
  } catch (e) {
  } finally {
  }
}

const createAnswerComment = async (newComment: string, answer: UserAnswer) => {
  if (!currentQuession.value) return
  try {
    const commentForm = new CommentForm()
    commentForm.body = newComment
    commentForm.commentableId = answer.id
    commentForm.commentableType = "Answer"
    await api.comment.create(commentForm)
    currentQuession.value = await api.userQuestion.show(
      `${currentQuession.value.id}`
    )
    answer.showCommentForm = false
  } catch (e) {
  } finally {
  }
}

const createComment = async (newComment: string) => {
  if (!currentQuession.value) return
  try {
    const commentForm = new CommentForm()
    commentForm.body = newComment
    commentForm.commentableId = currentQuession.value.id
    commentForm.commentableType = "Question"
    await api.comment.create(commentForm)
    currentQuession.value = await api.userQuestion.show(
      `${currentQuession.value.id}`
    )
    currentQuession.value.showCommentForm = false
  } catch (e) {
  } finally {
  }
}

const createCommentChannel = () => {
  if (!currentQuession.value) return
  removeChannel('QuestionCommentChannel')
  channel.value = makeChannel(
    'QuestionCommentChannel',
    async (e: any) => {
      getCurrentQuestion()
    },
    () => {
      channel.value.send({
        action: 'follow',
        data: {
          relativeable_id: currentQuession.value!.id,
          relativeable_type: 'Question'
        }
      })
    },
  )
}

onMounted(async () => {
  await getCurrentQuestion()
  if (currentQuession.value) {
    createCommentChannel()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "h5 mb-0 modal-title d-flex align-center",
          id: "commentModalLabel",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.onBack && __props.onBack(...args)))
        }, [...(_cache[6] || (_cache[6] = [
          _createElementVNode("i", { class: "bi bi-chevron-left" }, null, -1 /* CACHED */),
          _createElementVNode("span", { class: "body-1" }, "戻る", -1 /* CACHED */)
        ]))]),
        (__props.showCloseButton)
          ? (_openBlock(), _createElementBlock("button", _hoisted_3))
          : _createCommentVNode("v-if", true)
      ]),
      (currentQuession.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "notice"),
            _createElementVNode("article", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_v_btn, {
                    icon: "",
                    variant: "tonal",
                    size: "small",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (upVote(currentQuession.value.voteMark, currentQuession.value.id, 'Question'))),
                    class: _normalizeClass({ 'bg-success': currentQuession.value.voteMark == 1 })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                          _createTextVNode("mdi-chevron-up", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["class"]),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(currentQuession.value.voteMark), 1 /* TEXT */),
                  _createVNode(_component_v_btn, {
                    icon: "",
                    variant: "tonal",
                    size: "small",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (downVote(currentQuession.value.voteMark, __props.question.id, 'Question'))),
                    class: _normalizeClass({ 'bg-success': currentQuession.value.voteMark == -1 })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                          _createTextVNode("mdi-chevron-down", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["class"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("h2", _hoisted_10, _toDisplayString(currentQuession.value.title), 1 /* TEXT */),
                  _createElementVNode("p", _hoisted_11, _toDisplayString(dateFormat(currentQuession.value.createdAt)), 1 /* TEXT */),
                  _cache[9] || (_cache[9] = _createElementVNode("hr", { class: "my-3" }, null, -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", {
                      class: "mb-4 html-body",
                      innerHTML: currentQuession.value.renderedBody
                    }, null, 8 /* PROPS */, _hoisted_13)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                (currentQuession.value.user)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      (currentQuession.value.user.image)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "img-fluid",
                            src: currentQuession.value.user.image.url
                          }, null, 8 /* PROPS */, _hoisted_16))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(currentQuession.value.user.name), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("ul", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentQuession.value.comments, (comment) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "row pt-5",
                    key: comment.id,
                    id: `comment-${comment.id}`
                  }, [
                    _createElementVNode("div", _hoisted_20, [
                      (comment.user.image)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "img-fluid",
                            src: comment.user.image.url
                          }, null, 8 /* PROPS */, _hoisted_21))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, _toDisplayString(comment.user.name), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_25, _toDisplayString(dateFormat(comment.createdAt)), 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", {
                          class: "html-body",
                          innerHTML: comment.renderedBody
                        }, null, 8 /* PROPS */, _hoisted_27)
                      ])
                    ])
                  ], 8 /* PROPS */, _hoisted_19))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _createVNode(CommentCreation, {
                showCommentForm: currentQuession.value.showCommentForm,
                onCancel: 
            () => {
              currentQuession.value.showCommentForm = false;
            }
          ,
                onOpen: 
            () => {
              currentQuession.value.showCommentForm = true;
            }
          ,
                createComment: 
            (newComment) => {
              createComment(newComment);
            }
          
              }, null, 8 /* PROPS */, ["showCommentForm", "onCancel", "onOpen", "createComment"])
            ]),
            _createElementVNode("section", null, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("h3", _hoisted_29, "アンサーを投稿する", 512 /* NEED_PATCH */),
                _createVNode(_component_v_btn, {
                  icon: "",
                  variant: "flat",
                  size: "small",
                  color: "teal",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (answerToggle.value = !answerToggle.value))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                        _createTextVNode("mdi-plus", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _cache[11] || (_cache[11] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
              (answerToggle.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(Simplemde, {
                      modelValue: newAnswer.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newAnswer).value = $event)),
                      rows: 3,
                      name: "answer-body"
                    }, null, 8 /* PROPS */, ["modelValue"]),
                    _createElementVNode("div", _hoisted_30, [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_file_input, {
                            modelValue: answerFiles.value,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((answerFiles).value = $event)),
                            label: "素材をアップロード",
                            multiple: "",
                            "prepend-icon": "mdi-paperclip"
                          }, {
                            selection: _withCtx(({ fileNames }) => [
                              _createVNode(_component_v_chip, {
                                size: "small",
                                label: "",
                                color: "primary"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(fileNames.join(', ')), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */)
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["modelValue"])
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _createElementVNode("div", { class: "my-5" }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn rounded-pill bg-dark text-white",
                        onClick: createAnswer
                      }, " アンサーする ")
                    ])
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true)
            ]),
            (currentQuession.value.userAnswers.length > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "h6 fw-bold" }, "アンサー一覧", -1 /* CACHED */)),
                  _cache[13] || (_cache[13] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
                  _createElementVNode("ul", _hoisted_31, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentQuession.value.userAnswers, (answer) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "row my-5",
                        key: answer.id,
                        id: `answer-${answer.id}`
                      }, [
                        _createElementVNode("div", _hoisted_33, [
                          (answer.user.image)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                class: "img-fluid",
                                src: answer.user.image.url
                              }, null, 8 /* PROPS */, _hoisted_34))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, _toDisplayString(answer.user.name), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_38, _toDisplayString(dateFormat(answer.createdAt)), 1 /* TEXT */)
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("div", {
                              class: "html-body",
                              innerHTML: answer.renderedBody
                            }, null, 8 /* PROPS */, _hoisted_40)
                          ]),
                          _createElementVNode("ul", _hoisted_41, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(answer.comments, (comment) => {
                              return (_openBlock(), _createElementBlock("li", {
                                class: "row pt-5",
                                key: comment.id,
                                id: `comment-${comment.id}`
                              }, [
                                _createElementVNode("div", _hoisted_43, [
                                  (comment.user.image)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        class: "img-fluid",
                                        src: comment.user.image.url
                                      }, null, 8 /* PROPS */, _hoisted_44))
                                    : _createCommentVNode("v-if", true)
                                ]),
                                _createElementVNode("div", _hoisted_45, [
                                  _createElementVNode("div", _hoisted_46, [
                                    _createElementVNode("div", _hoisted_47, _toDisplayString(comment.user.name), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_48, _toDisplayString(dateFormat(comment.createdAt)), 1 /* TEXT */)
                                  ]),
                                  _createElementVNode("div", _hoisted_49, [
                                    _createElementVNode("div", {
                                      class: "html-body",
                                      innerHTML: comment.renderedBody
                                    }, null, 8 /* PROPS */, _hoisted_50)
                                  ])
                                ])
                              ], 8 /* PROPS */, _hoisted_42))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]),
                          _createElementVNode("div", _hoisted_51, [
                            _createVNode(CommentCreation, {
                              showCommentForm: answer.showCommentForm,
                              onCancel: 
                    () => {
                      answer.showCommentForm = false;
                    }
                  ,
                              onOpen: 
                    () => {
                      answer.showCommentForm = true;
                    }
                  ,
                              createComment: 
                    (newComment) => {
                      createAnswerComment(newComment, answer);
                    }
                  
                            }, null, 8 /* PROPS */, ["showCommentForm", "onCancel", "onOpen", "createComment"])
                          ])
                        ]),
                        _createCommentVNode(" /.col ")
                      ], 8 /* PROPS */, _hoisted_32))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" /.modal-body ")
    ]),
    _createCommentVNode(" /.modal-content ")
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}
}

})